import styled, {css} from 'styled-components'
import PropTypes from 'prop-types'
import React from 'react'

const getLinkColorBase = ({type, theme}) => (type === 'offer' ? '#c00' : theme.colors[type].base)
const getLinkColorDark = ({type, theme}) => (type === 'offer' ? '#c00' : theme.colors[type].dark)
const getLinkColorLight = ({type, theme}) => (type === 'offer' ? '#c00' : theme.colors[type].light)

// TODO: Check the shadows
const Link = styled.a`
  text-decoration: none;
  padding: ${({withPadding}) => (withPadding ? '0 15px' : '0')};
  font-size: ${({size, theme}) => (size === 'small' ? theme.typography.fontSize.fs2 : theme.typography.fontSize.fs3)};
  line-height:  ${({size, theme}) => (size === 'small' ? theme.typography.lineHeight.fs2 : theme.typography.lineHeight.fs3)};
  font-weight: ${({bold}) => (bold ? 'bold' : 'normal')};
  cursor: pointer;
  color: ${getLinkColorBase};
  
  &:hover, &:hover:visited {
    color: ${getLinkColorDark}
    i {
        color: ${({isOfferLink}) => (!isOfferLink ? getLinkColorDark : '#c00')};
    }
  }
  
  ${({ellipsis}) => (ellipsis ? css`

    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  ` : '')}
  
  ${({noWrap}) => (noWrap ? css`
    display: block;
    white-space: nowrap;
  ` : '')}
  
  ${({isAccountLink}) => (isAccountLink ? css`

    display: flex;
    align-items: center;
  ` : '')}
  
  &:visited {
    color: ${({isAccountLink}) => (!isAccountLink ? getLinkColorLight : getLinkColorBase)};
  }
  
  i {
    display: inline-block;
    vertical-align: middle;
  }

  &.iconLeft i {
    margin-right: 5px;
  }

  &.iconRight i {
    margin-left: 5px;
  }
`;

const LinkComponent = ({children, ...other}) => (
  <Link {...other}>{children}</Link>
)

LinkComponent.props = {
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'offer']),
  size: PropTypes.oneOf(['small', 'default']),
  bold: PropTypes.bool,
  withPadding: PropTypes.bool,
  ellipsis: PropTypes.bool
}

LinkComponent.defaultProps = {
  type: 'primary',
  size: 'small',
  bold: true,
  withPadding: true,
  ellipsis: false
}

export default LinkComponent;
